import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async'; // SEO Motorumuz
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Footer from './components/Footer'; 
import FloatingContact from './components/FloatingContact'; 
import Admin from './components/Admin'; 
import Projeler from './pages/Projeler'; 
import Kameralar from './pages/Kameralar';
import KameraDetay from './components/KameraDetay';
import Urunler from './components/Urunler';
import UrunDetay from './components/UrunDetay';
import Iletisim from './pages/Iletisim';
import Blog from './pages/Blog';
import BlogDetay from './pages/BlogDetay';
import ScrollToTop from "./components/ScrollToTop"; // Asansör Motorumuz

import './App.css';

function App() {
  return (
    <HelmetProvider> {/* SİHİRLİ DOKUNUŞ 1: SEO Tabelalarını Yöneten Ana Motor En Dışta! */}
      <Router>
        <ScrollToTop /> {/* SİHİRLİ DOKUNUŞ 2: Sayfa her değiştiğinde bizi en yukarı ışınlayan asansör! */}
        
        <div className="App">
          {/* Navbar her sayfada en üstte sabit kalacak */}
          <Navbar /> 

          {/* Sayfa içerikleri burada değişecek */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/iletisim" element={<Iletisim/>} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/projeler" element={<Projeler />} />
            <Route path="/kamera" element={<Kameralar />} />
            <Route path="/kamera/:id" element={<KameraDetay />} />
            <Route path="/urunler" element={<Urunler />} />
            <Route path="/urun/:id" element={<UrunDetay />} />
            <Route path="/urunler/:kategoriParam" element={<Urunler />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogDetay />} />
          </Routes>

          {/* Yüzen iletişim butonları her sayfada bizimle gelsin */}
          <FloatingContact />

          {/* Footer her sayfanın en altında otomatik çıksın */}
          <Footer /> 
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;